import DataLoader from "../Utlis/DataLoader";

const GetPost = async (id) => {
  try {
    const response = await DataLoader({
      Path: `/api/v1/posts/FilterById/${id}`,
      Type: 'get'
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export default GetPost;
